import { Customer } from '../customer';
import { User, IUser } from '../user';
import { ICustomerActivityData } from './customeractivity.types';

export class CustomerActivity {
  actor: IUser;
  verb: string;
  action_object: Customer;

  id: number;
  timestamp: Date | string;

  constructor(data: ICustomerActivityData) {
    this.id = data.id;

    this.actor = new User(data.actor);
    this.action_object = new Customer(data.action_object);
    this.verb = data.verb;
    this.timestamp = data.timestamp;
  }
}
